export default __webpack_public_path__ + "static/media/l_wdt_c_4_5.46101aac.mp3";